import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const SCID_COOKIE_NAME = 'scid';
export const SCID_ROTATED_FLAG = '__scid_rotated_for_current_application';

export const getScid = () => {
  return Cookies.get(SCID_COOKIE_NAME);
};

export const setScidCookie = (scid) => {
  Cookies.set(SCID_COOKIE_NAME, scid, {
    // Session cookie (expires when the browser is closed). If persistence is required, add `expires`.
    sameSite: 'Lax',
    secure: globalThis.location?.protocol === 'https:',
    path: '/',
  });
};

export const clearScidCookie = () => {
  Cookies.remove(SCID_COOKIE_NAME, { path: '/' });
};

// Ensure scid exists (do not overwrite an existing value)

// Call on each "new application flow start": overwrite cookie with a new scid
export const rotateScid = () => {
  const next = uuidv4();
  setScidCookie(next);
  return next;
};
